import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardMedia,
  CardContent,
  IconButton,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import FavoriteIcon from "@mui/icons-material/Favorite";
import DarkBreadcrumbs from "../../components/common/DarkBreadcrumbs";

const Wishlist = () => {
  const wishlistItems = useSelector((state) => state.Wishlist?.items || []);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleRemove = (e, id) => {
    e.stopPropagation();
    dispatch({ type: "REMOVE_FROM_WISHLIST", payload: id });
  };

  return (
    <Box sx={{ backgroundColor: "#111", minHeight: "80vh", py: 4 }}>
      <Container maxWidth="xl">
        <DarkBreadcrumbs
          items={[
            { label: "Home", path: "/" },
            { label: "Saved Listings" },
          ]}
        />
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: { xs: "22px", md: "30px" },
            color: "#fff",
            mb: 3,
            mt: 2,
          }}
        >
          Saved Listings
        </Typography>

        {wishlistItems.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 8 }}>
            <Typography sx={{ color: "#ccc", fontSize: "18px" }}>
              You haven't saved any listings yet.
            </Typography>
            <Typography
              onClick={() => navigate("/listings")}
              sx={{
                color: "#FFC001",
                fontWeight: 600,
                fontSize: "15px",
                mt: 2,
                cursor: "pointer",
                "&:hover": { textDecoration: "underline" },
              }}
            >
              Browse Listings
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={2}>
            {wishlistItems.map((item) => (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} key={item.id}>
                <Card
                  onClick={() => navigate(`/listing/${item.id}`)}
                  sx={{
                    backgroundColor: "#1a1a1a",
                    border: "1px solid #333",
                    borderRadius: "10px",
                    cursor: "pointer",
                    transition: "0.3s all",
                    "&:hover": {
                      borderColor: "#FFC001",
                      boxShadow: "0 4px 15px rgba(255, 192, 1, 0.15)",
                    },
                  }}
                >
                  <Box sx={{ position: "relative" }}>
                    <CardMedia
                      sx={{
                        height: 180,
                        backgroundSize: "contain",
                      }}
                      image={item?.media?.[0]?.url}
                      title={item?.name}
                    />
                    <IconButton
                      onClick={(e) => handleRemove(e, item.id)}
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        backgroundColor: "rgba(0,0,0,0.5)",
                        "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
                      }}
                    >
                      <FavoriteIcon sx={{ color: "#FFC001", fontSize: 20 }} />
                    </IconButton>
                  </Box>
                  <CardContent>
                    <Typography
                      variant="h6"
                      noWrap
                      fontWeight="bold"
                      sx={{ color: "#fff", fontSize: "16px" }}
                    >
                      {item.name}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: { xs: "20px", md: "22px" },
                        fontWeight: "bold",
                        color: "#FFC001",
                        mt: 0.5,
                      }}
                    >
                      ${item.price}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Box>
  );
};

export default Wishlist;
